"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useEventListener_1 = __importDefault(require("../useEventListener"));
const CTRL_OR_META = "ctrlOrMetaKey";
var Modifier;
(function (Modifier) {
    Modifier["ALT"] = "altKey";
    Modifier["META"] = "metaKey";
    Modifier["CTRL"] = "ctrlKey";
    Modifier["SHIFT"] = "shiftKey";
    Modifier["CTRL_OR_META"] = "ctrlOrMetaKey";
})(Modifier || (Modifier = {}));
const checkModifierInEvent = (event, modifier) => {
    if (modifier === Modifier.CTRL_OR_META) {
        return event.ctrlKey || event.metaKey;
    }
    return event[modifier];
};
const checkWithoutModifierInEvent = (event) => {
    return !Object.values(useKeyEvent.modifiers).some((m) => {
        if (m !== CTRL_OR_META) {
            return !!event[m];
        }
    });
};
function useKeyEvent({ keys = [], callback, modifier, withoutAnyModifier, ref, ignoreDocumentFallback = false, capture = false, preventDefault = false, stopPropagation = false, keyEventName = "keydown" // need keydown and not keyup to prevent scrolling with prevent default, for example during menu keyboard navigation
 }) {
    const documentRef = (0, react_1.useRef)(document.body);
    const onKeyUpPress = (0, react_1.useCallback)((event) => {
        const { key } = event;
        if (!keys.includes(key)) {
            return;
        }
        if (modifier && !checkModifierInEvent(event, modifier)) {
            return;
        }
        if (withoutAnyModifier && !checkWithoutModifierInEvent(event)) {
            return;
        }
        if (preventDefault) {
            event.preventDefault();
        }
        if (stopPropagation) {
            event.stopPropagation();
        }
        callback(event);
    }, [keys, modifier, withoutAnyModifier, preventDefault, stopPropagation, callback]);
    let listenerRef;
    if (ref) {
        listenerRef = ref;
    }
    else if (ignoreDocumentFallback) {
        listenerRef = null;
    }
    else {
        listenerRef = documentRef;
    }
    (0, useEventListener_1.default)({
        eventName: keyEventName,
        callback: onKeyUpPress,
        ref: listenerRef,
        capture
    });
}
exports.default = useKeyEvent;
useKeyEvent.modifiers = Modifier;
